'use client';

import {
    Alert,
    AlertState,
    Button,
    Image,
    Modal,
    Sticker,
    Text,
    Title,
    TitleLevels,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

import { RepeaterProduct } from '@app-types/product';

import { MEDIA_BASE_URL } from '@helpers/config';

interface BboxOtisOptionModalProps {
    onClose: () => void;
    active: boolean;
    onAddOtisRepeater: () => void;
    isRepeaterAdded: boolean;
    shouldShowAlert: boolean;
    repeater: RepeaterProduct;
}

export default function BboxOtisOptionModal({
    onClose,
    active,
    onAddOtisRepeater,
    isRepeaterAdded,
    shouldShowAlert,
    repeater,
}: Readonly<BboxOtisOptionModalProps>) {
    return (
        <Modal active={active} onClose={onClose} closeIcon className='otis-modal'>
            <Title level={TitleLevels.TWO}>{repeater.name || 'Répéteur WiFi'}</Title>
            {repeater.promoLabel && (
                <Sticker variant={TrilogyColor.PRIMARY} small className='mt-2 mb-2'>
                    {repeater.promoLabel}
                </Sticker>
            )}
            <Text>
                {repeater.longDescription || (
                    <>
                        Vous habitez un logement de plus de 80 m²&nbsp;? Il y a un étage chez vous&nbsp;? Disponible en
                        option avec la B&YOU Pure fibre, le répéteur WiFi vous garantit une couverture WiFi
                        idéale&nbsp;!
                    </>
                )}
            </Text>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>+ {repeater.prices.final}€/mois</Text>
            <View className='has-text-centered mb-3 img-modal'>
                <Image
                    src={repeater.imgRepeater?.public_url || `${MEDIA_BASE_URL}/Repeteur.webp`}
                    alt='Box'
                    width={160}
                    height={200}
                    className='is-centered'
                />
            </View>
            <Alert
                alert={AlertState.WARNING}
                display={shouldShowAlert}
                title="Ajoutez d'abord l'offre Pure Fibre"
                description="L'option répéteur WiFi est seulement compatible avec une offre Pure Fibre. Ajoutez-en une pour continuer !"
            />

            <View className='pt-4'>
                <Button
                    variant={TrilogyColor.PRIMARY}
                    className='oisBg is-fullwidth has-byou-background mb-4'
                    onClick={onAddOtisRepeater}
                >
                    {isRepeaterAdded ? 'Retirer du panier' : 'Ajouter au panier'}
                </Button>
                <Button variant={TrilogyColor.TERTIARY} className='oisBg is-fullwidth' onClick={onClose}>
                    Fermer
                </Button>
            </View>
        </Modal>
    );
}
